import styled, { css } from 'styled-components';

export const ContentWrapper = styled.div`
  ${({ theme }) => css`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    gap: 40px;
    width: 100%;

    @media (max-width: ${theme.v2.breakpoints.sm}) {
      flex-direction: column;
      gap: 24px;
      align-items: flex-start;
    }
  `}
`;

export const DataBlocksWrapper = styled.div`
  ${({ theme }) => css`
    display: flex;
    flex-direction: row;
    gap: 32px;
    flex: 1;

    @media (max-width: ${theme.v2.breakpoints.sm}) {
      flex-direction: column;
      gap: 12px;
      width: 100%;
    }
  `}
`;

export const DataBlock = styled.div`
  display: flex;
  flex-direction: column;
`;

export const DataLabel = styled.span`
  ${({ theme }) => css`
    font-size: ${theme.v2.font.sizes.xxs};
    font-weight: ${theme.v2.font.weights.medium};
    line-height: 21px;
    color: ${theme.v2.colors.neutral.lowMedium};
    margin-bottom: 0;
  `}
`;

export const DataValue = styled.span`
  ${({ theme }) => css`
    font-size: ${theme.v2.font.sizes.xs};
    font-weight: ${theme.v2.font.weights.regular};
    line-height: 24px;
    color: ${theme.v2.colors.neutral.lowDark};
    margin-top: 0;
  `}
`;

export const ButtonWrapper = styled.div`
  ${({ theme }) => css`
    @media (max-width: ${theme.v2.breakpoints.sm}) {
      width: 100%;
    }
  `}
`;
